import { Box, Heading } from '@hawkins/components';
import { IconCheckmark, IconClock } from '@hawkins/assets';
import { Colors, Dimensions } from '@hawkins/variables';

type StatusBannerVariant = 'success' | 'pending';

export interface StatusBannerProps {
  text: string;
  variant: StatusBannerVariant;
}

const bgColorForVariant = (variant: StatusBannerVariant) => {
  if (variant === 'pending') {
    return Colors.Yellow50;
  }
  return Colors.Green50;
};

const iconForVariant = (variant: StatusBannerVariant) => {
  if (variant === 'pending') {
    return <IconClock fill={Colors.YellowT70} />;
  }
  return <IconCheckmark fill={Colors.Green600} />;
};

export function StatusBanner({ text, variant }: StatusBannerProps) {
  return (
    <Box
      alignItems="center"
      backgroundColor={bgColorForVariant(variant)}
      borderRadius={Dimensions.BorderRadius0}
      columnGap={Dimensions.Space12}
      display="flex"
      paddingX={Dimensions.Space32}
      paddingY={Dimensions.Space32}
      width='100%'
    >
      {iconForVariant(variant)}
      <Heading level={2}>{text}</Heading>
    </Box>
  );
}
